const DEAR_CHANNEL = "DEAR-INVENTORY";
// Backend (InventoryDearSystems) throws when no profile.ID is set on the DEAR
// channel entry, so we mirror that gate on the client to prevent the user
// reaching Stripe just to fail at order placement.
export function getDearCustomerId(channels) {
    return channels?.find((c) => c?.channel === DEAR_CHANNEL)?.profile?.ID;
}
export function hasDearCustomerLink(channels) {
    return !!getDearCustomerId(channels);
}
